module.exports = {
	
	// behaviour
  'responsive-filters' : 1200,
  'responsive-nav'     : 1040,
  'responsive-hero'    : 1040,
  'responsive-discover': 900,
  'responsive-map'     : 800,
  'responsive-featured': 800,
  'responsive-spacing' : 800,
  'responsive-buttons' : 800,

	// grids
  'grid-lg': 1020,
  'grid-md': 850,
  'grid-sm': 550,

	// devices
  'desktop-lg': 1400,
  'desktop-md': 1250,
  'desktop-sm': 1020,
  'tablet-xl' : 900,
  'tablet-lg' : 800,
  'tablet-md' : 700,
  'tablet-sm' : 600,
  'phone-xl'  : 480,
  'phone-lg'  : 420,
  'phone-md'  : 375,
  'phone-sm'  : 320,
};